module.exports = __webpack_public_path__ + "static/media/_DSC_0001a.eb49068f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/_DSC_0001a.JPG
// module id = 124
// module chunks = 0